import React from 'react';
import PropTypes from 'prop-types';
import {Box, Container, Grid, Heading, Text} from '@tenancy.nz/design-system';
import StyledLeftRightContent, {
  StyledHeadingDivider,
} from './LeftRightContent.styled';

function LeftRightContent({
  align,
  bgcolor,
  content,
  heading,
  rightContent,
  subheading,
}) {
  return (
    <StyledLeftRightContent align={align} bgcolor={bgcolor}>
      <Container fixed>
        {heading && (
          <Box mb="50px" display="flex" align="center" direction="column">
            <Heading
              as="h1"
              color="secondary"
              gutterBottom={false}
              align="center">
              <strong>{heading}</strong>
            </Heading>
            <StyledHeadingDivider />
          </Box>
        )}
        <Grid container spacing={5} alignItems="center">
          {!!rightContent && (
            <Grid
              item
              xs={12}
              md={5}
              order={{md: 2}}
              sx={{
                display: 'flex',
                justifyContent: {xs: 'center', md: 'flex-start'},
              }}>
              {rightContent}
            </Grid>
          )}

          <Grid
            item
            xs={12}
            {...(!!rightContent && {md: 7})}
            sx={{
              display: 'flex',
              justifyContent: {xs: 'center', md: 'flex-start'},
            }}>
            <Box
              sx={{
                maxWidth: {xs: '85%', sm: '90%'},
              }}>
              {subheading && (
                <Heading as="h3" color="textPrimary">
                  {subheading}
                </Heading>
              )}
              <Text as="div" variant="subtitle1">
                {content}
              </Text>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </StyledLeftRightContent>
  );
}

LeftRightContent.propTypes = {
  align: PropTypes.oneOf(['bottom', 'center', 'top']),
  bgcolor: PropTypes.oneOf(['default', 'light', 'transparent']),
  content: PropTypes.node,
  heading: PropTypes.node,
  rightContent: PropTypes.node,
  subheading: PropTypes.node,
};

LeftRightContent.defaultProps = {
  align: 'top',
  bgcolor: 'default',
  content: undefined,
  heading: undefined,
  subheading: undefined,
  rightContent: undefined,
};

export default LeftRightContent;
